import React from "react";

const features = [
  {
    title: "India’s Finest Faculty for IIT-JEE & NEET",
    desc: "Handpicked mentors with decades of experience",
    icon: "https://cdn-icons-png.flaticon.com/512/2921/2921222.png",
  },
  {
    title: "Stress-Free, Competitive Learning Environment",
    desc: "Balanced academics & mental wellness programs",
    icon: "https://cdn-icons-png.flaticon.com/512/3581/3581147.png",
  },
  {
    title: "Proven Track Record of Ranks in IIT-JEE & NEET",
    desc: "Consistent top ranks in JEE & NEET every year",
    icon: "https://cdn-icons-png.flaticon.com/512/1828/1828884.png",
  },
  {
    title: "Daily Practice Tests & Weekly Grand Tests",
    desc: "Structured exams to boost confidence",
    icon: "https://cdn-icons-png.flaticon.com/512/3135/3135767.png",
  },
  {
    title: "Advanced Study Material & Digital Resources",
    desc: "Curated notes, NCERT mastery, AI tools",
    icon: "https://cdn-icons-png.flaticon.com/512/2819/2819170.png",
  },
  {
    title: "Personal Mentorship & Academic Counseling",
    desc: "One-on-one mentorship for every student",
    icon: "https://cdn-icons-png.flaticon.com/512/1077/1077063.png",
  },
];

const FeatureCards = () => {
  return (
    <section className="bg-gray-50 py-16 px-4 sm:px-6 lg:px-16">
      <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
        Special Advantages of Rankridge
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
        {features.map((feature, index) => (
          <div
            key={index}
            className="flex flex-col items-center text-center px-6"
          >
            {/* Icon Wrapper */}
            <div className="w-20 h-20 rounded-full bg-gradient-to-br from-[#00a6a8] via-teal-500 to-sky-400 flex items-center justify-center shadow-lg hover:scale-105 hover:shadow-xl transition-all duration-300">
              <img
                src={feature.icon}
                alt={feature.title}
                className="w-10 h-10"
              />
            </div>

            {/* Title */}
            <h3 className="mt-5 text-lg font-semibold text-gray-800">
              {feature.title}
            </h3>

            {/* Description */}
            <p className="mt-2 text-sm text-gray-600">{feature.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeatureCards;
